import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { watchAuth, getUserRole } from "../services/authService";

export default function ProtectedRoute({ children, mustBeAdmin = false }) {
  const [state, setState] = useState({ loading: true, user: null, role: null });

  useEffect(() => {
    const unsub = watchAuth(async (u) => {
      if (!u) return setState({ loading: false, user: null, role: null });
      const role = await getUserRole(u.uid);
      setState({ loading: false, user: u, role });
    });
    return () => unsub();
  }, []);

  if (state.loading) return (
    <div className="d-flex vh-100 align-items-center justify-content-center">
      <div className="spinner-border" role="status" />
    </div>
  );

  if (!state.user) return <Navigate to="/login" replace />;
  if (mustBeAdmin && state.role !== "admin") return <Navigate to="/login" replace />;

  return children;
}
